module.exports = __webpack_public_path__ + "img/zuo.b65c9bfb.png";